<template>
  <RevCard class="flex max-w-[360px] flex-col gap-16 p-16">
    <RevIllustration
      :alt="title"
      class="rounded-lg overflow-hidden"
      :height="256"
      :src="image"
      :width="328"
    />
    <div class="flex flex-col gap-8">
      <h3 class="text-static-default-hi heading-2">
        {{ title }}
      </h3>
      <p class="text-static-default-mid body-1">
        {{ description }}
      </p>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'

defineProps<{
  title: string
  description: string
  image: string
}>()
</script>
